export enum ShareType {
  OFFICIAL='1', // 官方灵感集
  // EXCLUSIVE='2' // 专属灵感集
}
